import React from 'react';
import PropTypes from 'prop-types';

import * as icons from "./svg"
import classnames from "classnames"
import styles from "./index.css"

export default class Icon extends React.Component {

    static propTypes = {
        type: PropTypes.string,
        className: PropTypes.string,
        onClick: PropTypes.func.isRequired,
        notif: PropTypes.bool,
    }

    static defaultProps = {
        type: null,
        onClick: () => {},
    }

    render = () => {
        const {
            className,
            type,
            onClick,
            notif,
        } = this.props

        // console.log(className);
        const icon = icons[type]
        /* eslint-disable no-console */
        if(!icon) console.warn("The icon ",type, " is not available.");
        /* eslint-enable no-console */
        return (
            <span
                className={ classnames(className,styles.root) }
                onClick={ onClick }>
                {
                    notif &&
                    <span className={styles.notif}></span>
                }
                {icon && React.createElement(icon,this.props)}
            </span>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Icon/index.js